import { render, staticRenderFns } from "./RecargoUpdate.vue?vue&type=template&id=2eb01d5e&scoped=true&"
import script from "./RecargoUpdate.vue?vue&type=script&lang=js&"
export * from "./RecargoUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb01d5e",
  null
  
)

export default component.exports